const knownPayrollProviders = [
  "BrightPay",
  "Sage Payroll",
  "Sage 50 Payroll",
  "Sage Business Cloud Payroll",
  "Xero Payroll",
  "QuickBooks Payroll",
  "Staffology Payroll (IRIS)",
  "ADP Payroll",
  "Moorepay",
  "PayFit",
  "Payroo",
  "FreeAgent Payroll",
  "Capium Payroll",
  "Clear Books Payroll",
  "Octopaye",
  "SD Worx Payroll",
  "SAP UK Payroll",
  "Workday Payroll",
  "Rippling Payroll",
  "MHR (iTrent Payroll)",
  "Ciphr Payroll",
  "Civica Payroll",
  "Pento",
  "Fourth"
];

export default knownPayrollProviders;